const MONEY_UNITS = [
  { val: 1e15, suffix: 'Q' },
  { val: 1e12, suffix: 'T' },
  { val: 1e9, suffix: 'B' },
  { val: 1e6, suffix: 'M' },
  { val: 1e3, suffix: 'K' },
];

export function money(n: number, decimals = 2): string {
  if (!Number.isFinite(n)) return '—';
  const sign = n < 0 ? '-' : '';
  const abs = Math.abs(n);
  for (const { val, suffix } of MONEY_UNITS) {
    if (abs >= val) {
      return `${sign}$${(abs / val).toFixed(decimals)}${suffix}`;
    }
  }
  return `${sign}$${abs.toFixed(decimals)}`;
}

export function moneyFull(n: number): string {
  if (!Number.isFinite(n)) return '—';
  return n.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function pct(n: number, decimals = 2): string {
  if (!Number.isFinite(n)) return '—';
  const sign = n > 0 ? '+' : '';
  return `${sign}${(n * 100).toFixed(decimals)}%`;
}

export function priceFmt(n: number): string {
  if (!Number.isFinite(n)) return '—';
  if (n >= 1000) return n.toFixed(2);
  if (n >= 1) return n.toFixed(2);
  return n.toFixed(4);
}

export function compactNum(n: number): string {
  return Intl.NumberFormat('en-US', { notation: 'compact', maximumFractionDigits: 1 }).format(n);
}
